export default __webpack_public_path__ + "static/media/s-2.a359818b.jpg";